import React from 'react';

const RagnaWindow = props => {
    var _style = {...props.mainStyle};
    if(props.width) _style = {..._style,maxWidth:props.width}
    return (
      <div
        style={_style}
        className={(props.className?props.className:"") + " rwindow"}
        onClick={props.onClick??null}
      >
        <div style={props.boxStyle}>
          <div>
            <div>
              <i />
              <span> {props.title} </span>
              {props.closeFunc?
              <div>
                <i />
                <span onClick={props.closeFunc}>x</span></div>:<></>}
              <div style={{ cursor: "pointer" }} />
            </div>
          </div>
          <div style={{ padding: 15, flex: "1 1 0%", minHeight: props.minHeight ? props.minHeight : 50 }}>
            {props.children}
          </div>
            {
            props.footer ? 
              <div style={props.footer_options}>
                  {props.footer}
              </div>
            :
            null
            }
        </div>
      </div>
    );
  }
  
  export default RagnaWindow;
  